import { makeEnvelope } from './envelope';
import type { Modifiers, Send, WireKey } from './types';

// attachKeyboard 挂 keydown/keyup,转发到 agent。
// 建议挂到 document 而不是 video,以便键盘输入不依赖焦点。
// 调用方应在会话建立时 attach、会话结束时 detach。
export function attachKeyboard(target: Document | Window | HTMLElement, send: Send): () => void {
  const onKeyDown = (e: KeyboardEvent) => {
    // IME 合成期间不发 keyDown:compositionstart/update 已覆盖。
    if (e.isComposing || e.keyCode === 229) return;
    // 默认拦截所有键,避免浏览器快捷键干扰。调用方若想保留特定快捷键(例如 Esc 退出)
    // 可用 stopImmediatePropagation 自行覆盖。
    e.preventDefault();
    send(
      makeEnvelope<WireKey>('input.key', {
        type: 'keyDown',
        key: e.key,
        code: e.code,
        location: normalizeLocation(e.location),
        auto_repeat: e.repeat,
        modifiers: modifiersFromKey(e),
      }),
    );
  };

  const onKeyUp = (e: KeyboardEvent) => {
    if (e.isComposing || e.keyCode === 229) return;
    e.preventDefault();
    send(
      makeEnvelope<WireKey>('input.key', {
        type: 'keyUp',
        key: e.key,
        code: e.code,
        location: normalizeLocation(e.location),
        modifiers: modifiersFromKey(e),
      }),
    );
  };

  target.addEventListener('keydown', onKeyDown as EventListener);
  target.addEventListener('keyup', onKeyUp as EventListener);

  return () => {
    target.removeEventListener('keydown', onKeyDown as EventListener);
    target.removeEventListener('keyup', onKeyUp as EventListener);
  };
}

function modifiersFromKey(e: KeyboardEvent): Modifiers {
  return { alt: e.altKey, ctrl: e.ctrlKey, meta: e.metaKey, shift: e.shiftKey };
}

function normalizeLocation(loc: number): 0 | 1 | 2 | 3 {
  if (loc === 1 || loc === 2 || loc === 3) return loc;
  return 0;
}
